import { ChatUser } from "@virtualprogaming/js-public-sdk";
import classNames from "classnames";
import { isEmpty, map, partial } from "lodash";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import { LoadingIcon } from "~/ui/components/icons";
import { useChatAuthUserData } from "~/ui/context";

import { NoContentFound } from "../../noContentFound";
import { ChatUsersImage } from "../chatUserImage/ChatUserImage";

interface ChatUsersRendererProps {
  users: ChatUser[];
  onClick: (uid: string | number | undefined) => void;
  useDisplayName: boolean;
  isLoading: boolean;
  isActionLoading: boolean;
  actionItemId: number | string | null;
  icon?: React.ReactNode;
  wrapperClassname?: string;
  secondIconCondition?: {
    icon: React.ReactNode;
    arrayToFind: ChatUser[];
  };
  useId?: boolean;
}

export const ChatUsersRenderer: FC<ChatUsersRendererProps> = ({
  users,
  onClick,
  useDisplayName,
  isLoading,
  isActionLoading,
  actionItemId,
  icon,
  wrapperClassname,
  secondIconCondition,
  useId = false,
}) => {
  const { chatAuthUser } = useChatAuthUserData();

  return (
    <div
      className={classNames(
        "scroll-auto scroll-hide pd-t-md pd-b-sm",
        wrapperClassname ? wrapperClassname : "h-60"
      )}
    >
      {!isEmpty(users)
        ? map(
            users,
            (user: ChatUser) =>
              user.id !== chatAuthUser?.user.id && (
                <div
                  key={user.id}
                  className="flex items-center justify-between hover-light pointer mg-xs borderR-05"
                  onClick={partial(onClick, useId ? user.id : user.uid)}
                >
                  <div className="flex items-center gap-md pd-l-sm">
                    <ChatUsersImage user={user} />
                    <p>
                      {useDisplayName ? user.display_name : user.display_name}
                    </p>
                  </div>
                  {isActionLoading &&
                  (useId ? actionItemId : `u${actionItemId}`) ===
                    (useId ? user.id : user.uid) ? (
                    <LoadingIcon size="lg" className="mg-r-sm" />
                  ) : secondIconCondition ? (
                    secondIconCondition?.arrayToFind?.find(
                      (userData: ChatUser) =>
                        userData.uid === (useId ? user.id : user.uid)
                    ) ? (
                      secondIconCondition.icon
                    ) : (
                      icon
                    )
                  ) : (
                    icon
                  )}
                </div>
              )
          )
        : !isLoading && (
            <NoContentFound className="mg-t-2em mg-l-md w-90">
              <span className="text-white">
                <FormattedMessage
                  defaultMessage="No users were found"
                  id="M7HyWy"
                />
              </span>
            </NoContentFound>
          )}
    </div>
  );
};
